import { IColumns } from "../../Components/DataGrid/WSDataGrid";

export const billingColumns: IColumns[] = [
  { header: "#", fieldName: "id", type: "default", sortable: true },
  { header: "Actions", fieldName: "actions", type: "action" },
  { header: "Status", fieldName: "status", type: "status", sortable: true },
  {
    header: "Invoice No.",
    fieldName: "invoiceNo",
    type: "default",
    sortable: true
  },
  {
    header: "Order No.",
    fieldName: "orderNo",
    type: "default",
    sortable: true
  },
  {
    header: "Paid Amt",
    fieldName: "paidAmount",
    type: "default",
    sortable: true
  },
  {
    header: "Due Amt",
    fieldName: "dueAmount",
    type: "default",
    sortable: true
  },
  {
    header: "Total",
    fieldName: "totalAmount",
    type: "default",
    sortable: true
  },
  { header: "Tax", fieldName: "taxAmount", type: "default" },
  { header: "Taxable Amt", fieldName: "taxableAmount", type: "default" },
  { header: "Express Amt", fieldName: "expressAmount", type: "default" },
  { header: "Discount Amt", fieldName: "discountAmount", type: "default" }
];

export const billingData = [
  {
    id: 1,
    actions: "RECEIPT",
    status: "due",
    invoiceNo: "2502C183-9317",
    orderNo: "1086568",
    paidAmount: 105,
    dueAmount: 0,
    totalAmount: 105,
    taxAmount: 0,
    taxableAmount: 0,
    expressAmount: 0,
    discountAmount: 0
  },
  {
    id: 2,
    actions: "RECEIPT",
    status: "paid",
    invoiceNo: "2502C183-9315",
    orderNo: "98016",
    paidAmount: 40,
    dueAmount: 0,
    totalAmount: 40,
    taxAmount: 0,
    taxableAmount: 0,
    expressAmount: 0,
    discountAmount: 0
  },
  {
    id: 3,
    actions: "RECEIPT",
    status: "due",
    invoiceNo: "2502C183-9314",
    orderNo: "1085774",
    paidAmount: 865,
    dueAmount: 0,
    totalAmount: 865,
    taxAmount: 0,
    taxableAmount: 0,
    expressAmount: 0,
    discountAmount: 0
  },
  {
    id: 4,
    actions: "RECEIPT",
    status: "paid",
    invoiceNo: "2502C183-9313",
    orderNo: "1085678",
    paidAmount: 224,
    dueAmount: 0,
    totalAmount: 224,
    taxAmount: 0,
    taxableAmount: 0,
    expressAmount: 0,
    discountAmount: 0
  },

  {
    id: 5,
    actions: "RECEIPT",
    status: "paid",
    invoiceNo: "2502C510-9313",
    orderNo: "1085072",
    paidAmount: 224,
    dueAmount: 0,
    totalAmount: 224,
    taxAmount: 0,
    taxableAmount: 0,
    expressAmount: 0,
    discountAmount: 0
  },

  {
    id: 6,
    actions: "RECEIPT",
    status: "paid",
    invoiceNo: "2502D183-1313",
    orderNo: "1085600",
    paidAmount: 224,
    dueAmount: 0,
    totalAmount: 224,
    taxAmount: 0,
    taxableAmount: 0,
    expressAmount: 0,
    discountAmount: 0
  }
];
